// TestimonialPage.jsx — General Academic Sayings
import React from 'react';
import Slider from 'react-slick';

const testimonials = [
  {
    feedback:
      "The pursuit of knowledge is a journey that rewards curiosity, discipline, and an open mind.",
    source: "Academic Saying",
  },
  {
    feedback:
      "Research is the art of turning questions into discoveries and ideas into impact.",
    source: "Scholarly Insight",
  },
  {
    feedback:
      "Learning thrives where inquiry is encouraged, challenges are welcomed, and understanding is constantly refined.",
    source: "Educational Wisdom",
  },
  {
    feedback:
      "True scholarship is measured not only by answers found, but by the depth of questions one chooses to explore.",
    source: "Scholarly Reflection",
  },
];

const TestimonialPage = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="min-h-11 bg-gray-100 py-12">
      <div className="max-w-6xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-8 text-gray-800">
          Academic Sayings
        </h1>

        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="
                bg-white rounded-lg shadow-xl p-6 mx-4
                min-h-[200px] transition duration-300
                hover:shadow-2xl hover:scale-[1.03]
              "
            >
              <p className="text-lg italic text-gray-700 mb-4 leading-relaxed">
                “{testimonial.feedback}”
              </p>

              <p className="text-gray-600 text-sm font-medium text-right">
                — {testimonial.source}
              </p>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TestimonialPage;
